import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid'
import Button, { icons } from 'components/Button'
import ProductPackage from './ProductPackage'
function compare(a, b) {
    if (a.weight < b.weight) {
      return -1;
    }
    if (a.weight > b.weight) {
      return 1;
    }
    return 0;
  }

class ProductPackages extends Component {

    disableSelect({requireProduct}){
        
        const { enabledLessonTypes = [] } = this.props
    
        if(!requireProduct){
            return undefined
        }
        else{
            return !enabledLessonTypes.includes(requireProduct)
        }
    }

    render() {
        const {
            packages = [],
            children,
            togglePackage,
            addCustomPackage,
            onChange
        } = this.props
        return (
            <div className="fieldset-wrap" id="packages">
                <fieldset className="fieldset">
                    <legend className="legend">
                        <div className="form-group form-group__legend form-group__with-info info__pin-right">
                            4. Packages<br />
                            <small>Choose the packages you offer.</small>
                            {/*
                            <Info className="info__pin-right">
                                The default working hours can be changed later.
                                You can also easily block times from your calendar, so it's better to have more than less open times.
                            </Info>
                            */}
                        </div>
                    </legend>
                    {
                        packages.sort(compare).map((p, index) => (
                            <ProductPackage 
                                {...p} 
                                key={`${p.type}-${index}`} 
                                disableSelect={this.disableSelect(p)}
                                togglePackage={togglePackage}
                                onChange={onChange}
                            />
                        ))
                    }
                    <Row className="form--row form--row__add-package">
                        <Col xs={12}>
                            <Button 
                                type="button" 
                                icon={icons.PLUS} 
                                prependIcon={true} 
                                buttonType="ghost" 
                                onClick={ addCustomPackage } >
                                Add new package type
                            </Button>
                        </Col>
                    </Row>
                    { children }
                </fieldset>
            </div>
        )
    }
}

export default ProductPackages



// WEBPACK FOOTER //
// ./src/components/ProductPackages/ProductPackages.js